<template>
  <div class="modal fade modal-warning" id="return-modal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="closeReturnModal" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-reply mr-5"></i>{{'return' | translate}}</h4>
        </div>
        <div class="modal-body text-center">
          <p class="mt-10 lead"><span class="fa fa-reply mr-5"></span>{{'return_reason' | translate}}</p>
          <p class="margin"></p>
          <div class="row">
            <div class="col-xs-12">
              <select v-model="reason" class="form-control">
                <option class="warning" value="dont_like_item">1. {{'dont_like_item' | translate}}</option>
                <option class="warning" value="item_too_big">2. {{'item_too_big' | translate}}</option>
                <option class="warning" value="item_too_small">3. {{'item_too_small' | translate}}</option>
                <option class="warning" value="price_quality_ratio">4. {{'price_quality_ratio' | translate}}</option>
                <option class="warning" value="delivery_too_late">5. {{'delivery_too_late' | translate}}</option>
                <option class="warning" value="item_different_as_shown">6. {{'item_different_as_shown' | translate}}</option>
                <option class="warning" value="wrong_item">9. {{'wrong_item' | translate}}</option>
                <option class="warning" value="item_defect">10. {{'item_defect' | translate}}</option>
                <option class="warning" value="no_reason">{{'no_reason' | translate}}</option>
                <option class="warning" value="address_invalid">{{'address_invalid' | translate}}</option>
                <option class="warning" value="customer_decline">{{'customer_declined' | translate}}</option>
                <option class="warning" value="item_for_choice">{{'item_for_choice' | translate}}</option>
              </select>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-xs-12">
              <button id="abc" onclick="this.disabled=true" @click="pepe()" type="button" class="btn bg-success btn-block col-xs-3">{{'refund' | translate}}</button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-danger btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['action'],
  data () {
    return {
      reason: 'no_reason'
    }
  },
  methods: {
    pepe () {
      this.$emit('action', ['accepted', this.reason])
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/ReturnModal.vue